// 国际化英文表达部分
export default {
  title: {
    map: "Map",
    marking: "Marking",
    plot: "Plot",
    devicePositioning: "Locate",
    electronicFence: "Fence",
    warningDetails: "Alert Details",
  },
  common: {
    cancel: "Cancel",
    confirm: "OK",
    save: "Save",
    delete: "Delete",
    close: "Close",
    satellite: "Satellite",
    layer: "Standard",
    saving: "Saving...",
    saveSuccess: "Save Success",
    deleteTips: "Delete Tips",
    deleting: "Deleting...",
    deleteSuccess: "Delete Success",
    tips: "Tips",
    loading: "Loading...",
    modify: "Modify",
    revoke: "Revoke",
    yes: "Yes",
    no: "No",
    selectAll: "Select All",
    editing: "Editing",
    editSuccess: "Edit Success",
    add: "Add",
    uploading: "Uploading...",
    uploadFailed: "Upload Failed",
  },
  form: {
    keywordPlaceholder: "Enter keyword",
    tracking: "Mark Device",
    selectDevice: "Select Device",
    park: "Park",
    deviceType: "Type",
    deviceTypePlaceholder: "Select type",
    site: "Site",
    sitePlaceholder: "Select site",
    mac: "MAC",
    macPlaceholder: "Select MAC",
    latLon: "Lat/Lon",
    keyWordDeviceName: "Enter device name",
    fenceName: "Fence Name",
    fenceNamePlaceholder: "Enter fence name",
    selectSiteConfirm: "Selected {num} sites",
  },
  page: {
    AMap: "AMap",
    TMap: "Tencent Map",
    BMap: "Baidu Map",
    devicePositioning: {
      deviceName: "Device",
      lon: "Longitude",
      lat: "Latitude",
      altitude: "Altitude",
      altitudeUnit: "m",
      btnText: "Track",
    },
    electronicFence: {
      marking: "Marking",
    },
    plotManage: {
      plotAddTitle: "Add Plot",
      plotEditTitle: "Edit Plot",
      plotInfo: "Basic Info",
      plotName: "Plot Name",
      plotArea: "Area",
      plotAreaUnit: "mu",
      plotUserName: "Manager",
      plotPhone: "Phone",
      plotContractorDeadline: "Contract Term",
      plotContractorDeadlineUnit: "Years",
      plotIntroduction: "Description",
      plotImage: "Plot Image",
      plotNamePlaceholder: "Enter plot name",
      plotAreaPlaceholder: "Enter area",
      plotUserNamePlaceholder: "Enter manager name",
      plotPhonePlaceholder: "Enter phone number",
      plotContractorDeadlinePlaceholder: "Enter contract term",
      plotIntroductionPlaceholder: "Enter description",
      cropInfo: "Crop Info",
      cropName: "Crop Name",
      cropIntroduction: "Crop Description",
      cropImage: "Crop Image",
      cropNamePlaceholder: "Enter crop name",
      cropIntroductionPlaceholder: "Enter crop description",
      baseInfo: "Soil Fertility",
      baseThickness: "Soil Depth",
      baseLevel: "Soil Grade",
      baseDesc: "Fertility",
      baseName: "Parameter",
      baseValue: "Value",
      baseUnit: "Unit",
      baseThicknessPlaceholder: "Enter soil depth",
      baseLevelPlaceholder: "Enter soil grade",
      baseNamePlaceholder: "Enter parameter name",
      baseValuePlaceholder: "Enter value",
      baseUnitPlaceholder: "Enter unit",
    },
  },
  warning: {
    noPlot: "No plot info, please reselect.",
    latLonError: "Failed to get location, please retry.",
    noSite: "No sites for this type",
    noMac: "No MAC for this site",
    repeatedDotting: "Device already marked!",
    mapError: "Map not loaded. Please initialize map first.",
    noPermission: "No permission to operate!",
    noMobileIrrigationSite: "No mobile irrigation site info, please contact admin.",
    pleaseDrawFence: "Please draw a fence with at least three points.",
    noFenceSite: "Fence must bind at least one device site.",
    pleaseDrawPlot: "Please draw a plot with at least three points.",
    parkRealNameEmpty: "Park real name cannot be empty!",
    parkPhoneEmpty: "Park phone cannot be empty!",
    validityPhone: "Please enter a valid phone number!",
    plotNameEmpty: "Plot name cannot be empty!",
    plotAreaEmpty: "Plot area cannot be empty!",
    plotContractorDeadlineEmpty: "Contractor deadline cannot be empty!",
    plotIntroduceEmpty: "Plot introduction cannot be empty!",
    plotImageEmpty: "Please upload a plot image!",
    cropNameEmpty: "Crop name cannot be empty!",
    cropIntroduceEmpty: "Crop introduction cannot be empty!",
    cropImageEmpty: "Please upload a crop image!",
    plotBaseLevelEmpty: "Land fertility level cannot be empty!",
    plotBaseListLess: "Please add at least one land fertility information!",
    plotBaseNameEmpty: "Land fertility name cannot be empty, Index: {number}!",
    plotBaseValueEmpty: "Land fertility value cannot be empty, Index: {number}!",
    plotBaseUnitEmpty: "Land fertility unit cannot be empty, Index: {number}!",
  },
  tips: {
    deleteTrackInfo: "Delete {name} marker?",
    deviceRefreshPositioning: "Refresh {name} positioning?",
    openMapSoftware: "Open {software}?",
    cancelMarking: "Cancel marking?",
    saveMarking: "Save marking?",
    confirmFence: "Confirm fence?",
    deleteFence: "Delete fence {name}?",
    editFence: "Edit fence {name}?",
    toLocationPage: "Go to navigation page?",
    cancelMarkingPlot: "Cancel plot marking?",
    saveMarkingPlot: "Save plot marking?",
    deletePlot: "Delete plot {name}?",
    editPlot: "Edit plot {name}?",
  },
  empty: {
    featureEmpty: "Coming soon",
  },
};
